import { FC, useState } from "react";
import { Paper, Tab, Tabs as MuiTabs } from "@mui/material";
import { isArray } from "lodash";
import __ from "src/utils/Translations";
import PaperWrapper from "src/Pages/Company/Absences/Tabs/PaperWrapper";

interface ITabsProps {
  label?: string;
  config: {
    id: string;
    content: {
      label: string;
      component: React.JSX.Element;
    }[];
  };
  wrapContent?: boolean;
  dataTestId?: string;
}

const Tabs: FC<ITabsProps> = ({
  config,
  label = "",
  wrapContent = false,
  dataTestId,
}) => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Paper
        sx={{
          padding: "1rem 2rem",
          marginBottom: "2rem",
        }}
        data-testid={dataTestId}
      >
        <MuiTabs value={value} onChange={handleChange} aria-label={label}>
          {isArray(config.content) &&
            config.content.map((item, index) => (
              <Tab
                label={item.label}
                key={item.label}
                id={`${config.id}-${index}`}
                aria-controls={`${config.id}-panel-${index}`}
                data-testid={`${config.id}-${index}`}
              />
            ))}
        </MuiTabs>
      </Paper>

      <PaperWrapper wrapInPaper={wrapContent}>
        {isArray(config.content) &&
          config.content.map((item, index) => (
            <div
              role="tabpanel"
              hidden={value !== index}
              id={`${config.id}-panel-${index}`}
              aria-labelledby={`${config.id}-${index}`}
              data-testid={`${config.id}-panel-${index}`}
            >
              {value === index && item.component}
            </div>
          ))}
      </PaperWrapper>
    </>
  );
};

export default Tabs;
